import * as routes from 'api';
import { putJSON } from 'api/fetch';

import { refreshPage } from 'features/biller/util';

import { createAsyncGetAction, withAlerts } from 'util/redux';

export const actionTypes = {
  FETCH_MANAGERS_REQUEST: 'BILLING/FETCH_MANAGERS_REQUEST',
  FETCH_MANAGERS_SUCCESS: 'BILLING/FETCH_MANAGERS_SUCCESS',
  FETCH_MANAGERS_FAILURE: 'BILLING/FETCH_MANAGERS_FAILURE',
  CHANGE_CURRENT_LOCATION_REQUEST: 'BILLING/CHANGE_CURRENT_LOCATION_REQUEST',
  CHANGE_CURRENT_LOCATION_SUCCESS: 'BILLING/CHANGE_CURRENT_LOCATION_SUCCESS',
  CHANGE_CURRENT_LOCATION_FAILURE: 'BILLING/CHANGE_CURRENT_LOCATION_FAILURE',
};

export const fetchManagers = () =>
  withAlerts(
    createAsyncGetAction(routes.managersRoute(), [
      actionTypes.FETCH_MANAGERS_REQUEST,
      actionTypes.FETCH_MANAGERS_SUCCESS,
      actionTypes.FETCH_MANAGERS_FAILURE,
    ])
  );

export const changeCurrentLocation = id => dispatch => {
  dispatch({ type: actionTypes.CHANGE_CURRENT_LOCATION_REQUEST });

  return putJSON(routes.changeCurrentLocationRoute(), { id })
    .then(response => {
      dispatch({
        type: actionTypes.CHANGE_CURRENT_LOCATION_SUCCESS,
        payload: { id, response },
      });
      // Update the URL query parameter before reloading
      const url = new URL(window.location.href);
      url.searchParams.set('current_location_id', id);
      window.history.replaceState({}, '', url);
      refreshPage();
      return response;
    })
    .catch(error => {
      dispatch({
        type: actionTypes.CHANGE_CURRENT_LOCATION_FAILURE,
        error,
      });
      throw error;
    });
};
